import cloneDeep from 'lodash/cloneDeep';

export default {
  contacts: state => {
    return cloneDeep(state.contacts);
  },

  contactLists: state => {
    return cloneDeep(state.lists);
  },

  getContact: state => contactId => {
    return cloneDeep(state.contacts.find(contact => contact.id === contactId));
  },

  filteredContactLists: state => (searchString = '') => {
    return cloneDeep(state.lists.filter(list => list.includes(searchString)));
  }
};
